import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = anon, object = user
  const [branding, setBranding] = useState(null);

  const loadBranding = useCallback(async () => {
    try {
      const { data } = await api.get("/branding");
      setBranding(data);
    } catch (e) {
      /* ignore */
    }
  }, []);

  const checkAuth = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch (e) {
      setUser(false);
    }
  }, []);

  const refreshUser = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      return data;
    } catch (e) {
      return null;
    }
  }, []);

  useEffect(() => {
    if (window.location.hash?.includes("session_id=")) {
      return; // AuthCallback will establish session
    }
    checkAuth();
    loadBranding();
  }, [checkAuth, loadBranding]);

  const logout = useCallback(async () => {
    try {
      await api.post("/auth/logout");
    } catch (e) {}
    setUser(false);
  }, []);

  return (
    <AuthContext.Provider value={{ user, setUser, refreshUser, logout, branding, loadBranding }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
